<mat-button-toggle-group class="menu-button">
  <button mat-raised-button [color]="color()" (click)="actionClicked()" class="menu-button-action">{{value().title}}</button>

  <button mat-raised-button [color]="color()" [matMenuTriggerFor]="menu" class="menu-button-icon">
    <mat-icon aria-hidden="false" aria-label="Expand Menu" fontIcon="arrow_drop_down"></mat-icon>
  </button>
</mat-button-toggle-group>

<mat-menu #menu="matMenu">
  @for (option of options(); track option.value) {
    <button mat-menu-item (click)="onOptionSelected(option)">
      @if (option.icon) {
        <mat-icon aria-hidden="true" [fontIcon]="option.icon" [color]="option.iconColor ?? 'accent'" [style.color]="option.iconColor"></mat-icon>
      }
      
      {{option.title}}
    </button>
  }
</mat-menu>